/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AddUpdateJobSubComponentModal_job$ref: FragmentReference;
declare export opaque type AddUpdateJobSubComponentModal_job$fragmentType: AddUpdateJobSubComponentModal_job$ref;
export type AddUpdateJobSubComponentModal_job = {|
  +id: string,
  +subComponents: {|
    +edges: ?$ReadOnlyArray<?{|
      +usageQty: ?number,
      +node: {|
        +id: string,
        +name: string,
      |},
    |}>
  |},
  +$refType: AddUpdateJobSubComponentModal_job$ref,
|};
export type AddUpdateJobSubComponentModal_job$data = AddUpdateJobSubComponentModal_job;
export type AddUpdateJobSubComponentModal_job$key = {
  +$data?: AddUpdateJobSubComponentModal_job$data,
  +$fragmentRefs: AddUpdateJobSubComponentModal_job$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "AddUpdateJobSubComponentModal_job",
  "type": "Job",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "subComponents"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": "subComponents",
      "name": "__JobSubComponents_subComponents_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "JobSubComponentConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "JobSubComponentEdge",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "usageQty",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd8d176685395aa42a968fbc54d412fac';
module.exports = node;
